import { Link } from 'react-router-dom';
import Routes from '../configuration/routes/RouteList';

const sectionStyle = {
  marginBottom: '28px',
};

const headingStyle = {
  fontSize: '18px',
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: 'oklch(0.97 0.004 260)',
  margin: '0 0 10px',
} as const;

const paragraphStyle = {
  margin: 0,
  fontSize: '14px',
  lineHeight: 1.7,
  color: 'oklch(0.68 0.01 260)',
} as const;

const Terms = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'oklch(0.13 0.008 260)',
        color: 'oklch(0.97 0.004 260)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <title>NiuMedia Terms of Service</title>

      <div
        style={{
          maxWidth: '760px',
          margin: '0 auto',
          padding: '40px 24px 72px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '40px',
            flexWrap: 'wrap',
          }}
        >
          <Link
            to={Routes.Landing}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              textDecoration: 'none',
            }}
          >
            <span
              style={{
                fontWeight: 800,
                fontSize: '16px',
                letterSpacing: '-0.04em',
                background:
                  'linear-gradient(135deg, oklch(0.78 0.18 260), oklch(0.65 0.22 300))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              NM
            </span>
            <span style={{ fontSize: '15px', fontWeight: 600, color: 'oklch(0.9 0.004 260)' }}>
              NiuMedia
            </span>
          </Link>

          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <Link
              to={Routes.Privacy}
              style={{ color: 'oklch(0.72 0.18 265)', textDecoration: 'none', fontSize: '13px' }}
            >
              Privacy Policy
            </Link>
            <Link
              to={Routes.Login}
              style={{ color: 'oklch(0.6 0.01 260)', textDecoration: 'none', fontSize: '13px' }}
            >
              Sign in
            </Link>
          </div>
        </div>

        <div
          style={{
            borderRadius: '20px',
            border: '1px solid oklch(1 0 0 / 0.1)',
            background: 'oklch(0.17 0.008 260)',
            padding: '36px 32px',
            boxShadow: '0 24px 48px oklch(0 0 0 / 0.32)',
          }}
        >
          <p
            style={{
              margin: '0 0 10px',
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'oklch(0.72 0.18 265)',
            }}
          >
            Legal
          </p>
          <h1
            style={{
              margin: '0 0 10px',
              fontSize: '34px',
              lineHeight: 1.1,
              letterSpacing: '-0.04em',
              color: 'oklch(0.98 0.004 260)',
            }}
          >
            Terms of Service
          </h1>
          <p style={{ ...paragraphStyle, marginBottom: '32px' }}>
            Effective date: March 29, 2026. By accessing or using NiuMedia, you agree to these
            terms. If you do not agree, do not use the service.
          </p>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Use of the service</h2>
            <p style={paragraphStyle}>
              You may use NiuMedia only in compliance with applicable law and only for content that
              you have the right to access, process, or store. You are responsible for your account
              activity and for the content you submit.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Accounts and access</h2>
            <p style={paragraphStyle}>
              You must provide accurate account information and keep your login method secure. We
              may suspend or terminate access if we reasonably believe the service is being abused,
              used unlawfully, or operated in a way that harms the platform or other users.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Content and responsibility</h2>
            <p style={paragraphStyle}>
              You retain responsibility for the media, transcripts, and notes associated with your
              account. NiuMedia does not claim ownership over your content, but you grant us the
              rights needed to host, process, and deliver the features you requested.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Availability</h2>
            <p style={paragraphStyle}>
              We may change, improve, pause, or discontinue features at any time. The service is
              provided on an “as is” and “as available” basis without warranties of uninterrupted
              availability or perfect accuracy.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Limitation of liability</h2>
            <p style={paragraphStyle}>
              To the maximum extent permitted by law, NiuMedia will not be liable for indirect,
              incidental, special, consequential, or punitive damages arising from your use of the
              service. Your sole remedy for dissatisfaction is to stop using it.
            </p>
          </section>

          <section style={{ ...sectionStyle, marginBottom: 0 }}>
            <h2 style={headingStyle}>Changes</h2>
            <p style={paragraphStyle}>
              We may revise these terms from time to time. Continued use of NiuMedia after an
              update means you accept the revised terms.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
